import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { x: "4", y: "4", width: "16", height: "16", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { x: "9", y: "9", width: "6", height: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 20v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 15h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 9h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 15h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 9h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 20v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Cpu";
const Cpu = memo(themed(Icon));
export {
  Cpu
};
//# sourceMappingURL=cpu.js.map
